import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MenuItemModel } from "../../../models/menu-item";

interface MenuItemProps {
  menuItems: MenuItemModel[];
}

export default function MenuItem({ menuItems }: MenuItemProps) {
  const { t } = useTranslation();
  const currentURLRouteName = useLocation().pathname;
  const currentURLRouteNameToOBJ: any = currentURLRouteName.split("/");
  const currentURLRouteNameTitleCapit =
    currentURLRouteNameToOBJ[1].charAt(0).toUpperCase() +
    currentURLRouteNameToOBJ[1].slice(1);

  var navigate = useNavigate();

  const navigateToPage = (menuItem: MenuItemModel) => {
    if (menuItem.isexternal) {
      if (menuItem.title == "Open Ticket") {
        window.open(menuItem.link, "_blank");
      } else {
        window.open(process.env.REACT_APP_MVC_URL + menuItem.link, "_blank");
      }
    } else {
      navigate(menuItem.link);
    }
  };

  return (
    <ul className="mainnav__menu nav flex-column mainnav-parent">
      {menuItems?.map((menuItem: MenuItemModel, i: number) =>
        menuItem?.menuitems &&
        typeof menuItem?.menuitems !== "undefined" &&
        menuItem.menuitems.length > 0 ? (
          <li className="nav-item has-sub" key={i}>
            <a
              href="javascript:void(0)"
              className={`mininav-toggle nav-link ${
                currentURLRouteNameTitleCapit === menuItem.title ? "active" : ""
              }  ${menuItem.title == "Support"  ? "" : "active"}`} style={{backgroundColor: "transparent",
              color: "#25476a"}}
            >
              {typeof menuItem.icon !== "undefined" && menuItem.icon && (
                /* <i className={menuItem.icon + " fs-5 me-2"}></i> */
                <span className="material-symbols-outlined">
                  {menuItem.icon}
                </span>
              )}
              <span className="nav-label dashboard-style">
                {t(menuItem.title)}
              </span>
            </a>
            <ul
              className="mininav-content nav collapse mainnav-child"
              id="popupmenu"
              style={{ position: "absolute", zIndex: "999999" }}
            >
              <MenuItem menuItems={menuItem.menuitems} />
            </ul>
          </li>
        ) : (
          <li className="nav-item" key={i}>
            <a
              href="javascript:void(0)"
              onClick={() => {
                navigateToPage(menuItem);
              }}
              className={`nav-link ${
                menuItem.link === currentURLRouteName
                  ? "active-link-custom"
                  : ""
              } ${
                currentURLRouteNameToOBJ[1] == "" &&
                menuItem.link == "/aura-camera/operations"
                  ? "active-link-custom"
                  : ""
              }
              ${
                currentURLRouteNameToOBJ[2] == "operation-details" &&
                menuItem.link == "/aura-camera/operations"
                  ? "active-link-custom"
                  : ""
              }

              ${
                currentURLRouteNameToOBJ[2] == "sites-creation" &&
                menuItem.link == "/aura-camera/sites"
                  ? "active-link-custom"
                  : ""
              }

              ${
                currentURLRouteNameToOBJ[2] == "camera-operator-creation" &&
                menuItem.link == "/aura-camera/camera-operators"
                  ? "active-link-custom"
                  : ""
              }

              `}
            >
              <span className="material-symbols-outlined">{menuItem.icon}</span>{" "}
              {t(menuItem.title)}
            </a>
          </li>
        )
      )}
    </ul>
  );
}
